(function () {
  // Hysteresis, not one threshold: right around the edge of fitting, a
  // scrollbar appearing/disappearing (as page content height settles) can
  // shift the real available width by more than this margin, which was
  // observed to flip a borderline viewport width between nav and drawer
  // mode on different loads of the same width. Requiring a bigger, more
  // comfortable margin to switch BACK to the full nav than the margin that
  // triggers falling back to the drawer stops that from oscillating.
  var FALLBACK_GAP = 0; // switch to drawer once clearance drops to/below this
  var RECOVER_GAP = 24; // only switch back to full nav above this clearance
  var BREAKPOINT = 1280;

  // The nav's CSS max-width is a guessed calc(100vw - Npx) that doesn't
  // reliably match where the search box/cart actually render at every
  // breakpoint tier, so instead of trusting it we measure the real
  // right-hand boundary each time.
  function rightBoundary(nav) {
    var candidates = document.querySelectorAll('.bz-naturalist-header-search, header-actions');
    var boundary = Infinity;
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el === nav || nav.contains(el)) continue;
      var style = getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') continue;
      var rect = el.getBoundingClientRect();
      if (rect.width <= 0) continue;
      if (rect.left < boundary) boundary = rect.left;
    }
    return boundary;
  }

  function clearance(nav) {
    if (nav.scrollWidth > nav.clientWidth + 1) return -Infinity;
    var boundary = rightBoundary(nav);
    if (boundary === Infinity) return Infinity;
    return boundary - nav.getBoundingClientRect().right;
  }

  function fitNav(header, nav) {
    if (window.innerWidth < BREAKPOINT) {
      header.removeAttribute('data-bz-nav-fits');
      return;
    }

    // Opening the mobile/fallback drawer engages scroll-lock, which hides
    // the page's own scrollbar and widens the effective viewport by that
    // scrollbar's width. At a borderline width that's enough to flip this
    // check mid-open, hiding the very drawer panel the visitor just opened.
    // Leave the current state alone while the drawer is open.
    if (header.querySelector('.menu-drawer-container[open]')) return;

    // Same problem, different trigger: opening one of the nav's own Shop /
    // Learn / Help dropdown panels makes its (much wider) absolutely
    // positioned panel count toward the nav's scrollable overflow, which
    // clearance() below reads as the nav itself no longer fitting. That
    // falsely flips data-bz-nav-fits to "false" and hides the very dropdown
    // the visitor just opened. Leave the current state alone while any of
    // the nav's own dropdowns are open.
    if (nav.querySelector('.bz-naturalist-header-menu[open]')) return;

    // Measuring while the nav is already hidden (drawer mode) reads a
    // stale/irrelevant box, so briefly reveal it to measure, then let the
    // decision below set the real display state via the attribute.
    var wasHidden = header.getAttribute('data-bz-nav-fits') === 'false';
    if (wasHidden) header.setAttribute('data-bz-nav-fits', 'true');

    var gap = clearance(nav);
    var currentlyFallback = wasHidden;
    var fits = currentlyFallback ? gap > RECOVER_GAP : gap > FALLBACK_GAP;

    header.setAttribute('data-bz-nav-fits', fits ? 'true' : 'false');
  }

  function init() {
    var header = document.getElementById('header-component');
    var navs = document.querySelectorAll('.bz-naturalist-header-nav');
    if (!header || !navs.length) return;

    function fitAll() {
      navs.forEach(function (nav) { fitNav(header, nav); });
    }

    fitAll();

    // Plain resize covers window/browser resizing while this tab is active.
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fitAll, 150);
    });

    // ResizeObserver catches layout changes a window resize event doesn't:
    // the search box or cart column changing width (e.g. a cart badge
    // appearing/disappearing), independent of the viewport itself changing.
    if (window.ResizeObserver) {
      var roTimer;
      var ro = new ResizeObserver(function () {
        clearTimeout(roTimer);
        roTimer = setTimeout(fitAll, 100);
      });
      document.querySelectorAll('.bz-naturalist-header-search, header-actions').forEach(function (el) {
        ro.observe(el);
      });
    }

    // A window resize while this tab is backgrounded can leave a stale
    // reading in place (Chrome throttles timers in hidden tabs), so re-fit
    // as soon as the tab becomes visible again. pageshow also covers
    // bfcache restores (back/forward navigation).
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') fitAll();
    });
    window.addEventListener('pageshow', fitAll);

    // Custom fonts swapping in after the initial fit can change each
    // link's real rendered width; refit once webfonts finish loading.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitAll).catch(function () {});
    }

    // Last-resort safety poll: cheap (a handful of getBoundingClientRect
    // reads), and guarantees this self-corrects within ~1s regardless of
    // what caused a stale reading, instead of depending on catching every
    // possible trigger individually.
    setInterval(fitAll, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
